import axios from "axios";
import React, { useState } from "react";

interface UserDetails {
  role: string;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  phone_number: string;
  password: string;
}

function PasswordChange() {
  const api = process.env.REACT_APP_API_URL as string;
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");

  // Handle Change Password
  const handleChangePassword = async () => {
    setError("");
    setSuccess("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Please fill all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    try {
      const response = await axios.put(`${api}/admin/1`, {
        password: newPassword,
      });

      if (response.data.status === "success") {
        setSuccess("Password updated successfully!");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setError("Failed to update password.");
      }
    } catch (err: any) {
      setError("Unable to update password.");
      console.error("Password update failed:", err);
    }
  };

  return (
    <>
      <div className="w-[100%] h-auto p-8">
        <div className="w-[100%] bg-[#fff] rounded-xl pb-2 ">
          <div className="w-[100%]">
            <h1 className="text-[20px] font-[700] text-gray-800 py-[16px] px-[24px]">
              Change Password
            </h1>
          </div>
          <div className="wi-[100%] border-b-[1px] border-[#c0bebe] border-dashed"></div>
          <div className=" w-[100%] py-[20px] px-[24px]">
            <div className=" w-[100%] border-[1px] border-[#000]">
              <div className="w-full space-y-4 p-4">
                <div className="w-full">
                  <label className="block text-[16px] font-medium text-[#555454] pr-4 mb-1">
                    Current Password
                  </label>
                  <input
                    type="password"
                    placeholder="Current Password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    className="  w-full bg-transparent font-bold text-[#555454] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] outline-none  placeholder:text-sm placeholder:font-normal placeholder:text-[#888888]"
                  />
                </div>

                <div className="w-full">
                  <label className="block text-[16px] font-medium text-[#555454] pr-4 mb-1">
                    New Password
                  </label>
                  <input
                    type="password"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="w-full bg-transparent font-bold text-[#555454] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] outline-none  placeholder:text-sm placeholder:font-normal placeholder:text-[#888888]"
                  />
                </div>

                <div className="w-full">
                  <label className="block text-[16px] font-medium text-[#555454] pr-4 mb-1">
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="w-full bg-transparent font-bold text-[#555454] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] outline-none  placeholder:text-sm placeholder:font-normal placeholder:text-[#888888]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Show Error or Success */}
        {error && <p className="text-red-500 mt-2">{error}</p>}
        {success && <p className="text-green-500 mt-2">{success}</p>}

        <div className="w-[100%] py-6">
          <button
            onClick={handleChangePassword}
            className="bg-[#7a70ba] text-white px-6 py-1  sm:w-[280px]  w-[100%] rounded-md hover:bg-[#6a60a8] transition-all duration-200"
          >
            Change Password
          </button>
        </div>
      </div>
    </>
  );
}

export default PasswordChange;
